module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_2.87c0965130fe28f318e7c5039c1b1b7c.png";